var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['eui-a-badge',
  _vm.color ? `-${_vm.color}`: '',
  { 'active': _vm.content > 0 },
  { '-inverted': _vm.inverted },
  { '-notification': _vm.notification }]},[(_vm.content < _vm.max)?[_vm._v(_vm._s(_vm.content))]:[_vm._v("+"+_vm._s(_vm.max))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }